export const ROUTE = {
  HOME: '/home',

  LOGOUT: '/logout',
  SURVEY: '/recruiter-survey',
  ERROR_404: '/404',
  GLOBAL_SEARCH: '/global-search',
  REVIEWS: '/candidate/reviews',

  NETWORK: '/candidate/network',
  MY_NETWORK: '/candidate/mynetwork',
  PEOPLE_YOU_MAY_KNOW: '/candidate/people-you-may-know',
  INBOX: '/candidate/inbox',
  JOBS: '/candidate/job',
  PROJECTS: '/candidate/project',

  ADD_RECOMMENDATION: '/recommendation/add',
  ADD_REVIEW_COMPANY: '/candidate/reviews/add-company-review',
  ADD_REVIEW_INTERVIEW: '/candidate/reviews/add-interview-review',
  ADD_REVIEW_EMPLOYEE: '/candidate/reviews/add-employee-review',

  CANDIDATE_PROFILE: '/candidate/profile',
  CANDIDATE_PREPARATORY: '/candidate/preparatory',
  CANDIDATE_APTITUDE: '/candidate/aptitude',
  CANDIDATE_APTITUDE_TEST: '/candidate/test/start',
  CANDIDATE_ACCOUNT: '/candidate/account',
  CANDIDATE_CONFIDENTIAL: '/candidate/confidential',
  CANDIDATE_UPGRADE_PREMIUM: '/candidate/premium',
  CANDIDATE_PREMIUM_SUCCESS: '/candidate/premium/success',
  CANDIDATE_ACCOUNT_REGISTRATION: '/candidate/registration',

  RECRUITER_MANAGE_CALENDAR: '/recruiter/calendar',
  RECRUITER_PURCHASE: '/recruiter/credits',

  SEARCH: '/recruiter/search',
  SEARCH_INBOUNDS: '/recruiter/inbounds',
  SEARCH_INBOUNDS_REQUIREMENTS: '/recruiter/inbounds/requirements',
  SEARCH_SHORTLIST: '/recruiter/shortlist',
  SEARCH_EMAILS_TEMPLATES: '/recruiter/emails-templates',
  SEARCH_SUBSCRIPTION: '/recruiter/subscription-searches',
  SEARCH_RATED: '/recruiter/rated',
  SEARCH_PROCESS_MANAGE: '/recruiter/process',
  SEARCH_PROCESS_ADD: '/recruiter/process/create',
  SEARCH_PROJECT_MANAGE: '/recruiter/project',
  SEARCH_PROJECT_ADD: '/recruiter/project/create',
  SEARCH_TEAM: '/recruiter/team',

  CHECKOUT_PREMIUM: '/candidate/checkout-premium',
  CHECKOUT_PREP: '/candidate/checkout-prep',
  CHECKOUT_PREMIUM_PREP: '/candidate/checkout-premium-prep',
  CHECKOUT_INBOUNDS: '/candidate/checkout-inbounds',
  CHECKOUT_CREDIT: '/recruiter/checkout-credit',
  CHECKOUT_CREDITS: '/recruiter/checkout-credits',

  START: '/start',
};

export const ROUTE_REGEXP = {
  HOME_NEWS: ROUTE.HOME + '/:filter(news)+',
  REVIEWS_ACTIONS:
    ROUTE.REVIEWS + '/add-:formType(company|interview|employee)+-review',
  JOB: ROUTE.JOBS + '/:id(\\d+)',
  PROJECT: ROUTE.PROJECTS + '/:id(\\d+)',

  CHECKOUT_RECRUITER: '/recruiter/checkout-:type(credit|credits)+',
  CHECKOUT_CANDIDATE:
    '/candidate/checkout-:type(inbounds|premium|prep|premium-prep)+',

  FIRM_PROFILE: '/firm/:firmname',

  FIRM_SECTION_REVIEWS: '/firm/:firmname/reviews',
  FIRM_SECTION_ABOUT: '/firm/:firmname/about',
  FIRM_SECTION_COMPENSATION: '/firm/:firmname/compensation',
  FIRM_SECTION_PORTFOLIO: '/firm/:firmname/portfolio',
  FIRM_SECTION_STRATEGY: '/firm/:firmname/strategy',

  FIRM_TAB:
    '/firm/:firmname/:tab(overview|about|reviews|compensation|portfolio|strategy)+',
  FIRM_REVIEW_FORM:
    '/firm/:firmname/:tab(add)+-:formType(company|employee|interview)+-review',
  FIRM_REVIEW: '/firm/:firmname/:type/:reviewName',

  SEARCH_SHORTLIST: ROUTE.SEARCH_SHORTLIST + '/:id(\\d+)',
  SEARCH_EMAILS_TEMPLATES_CREATE: ROUTE.SEARCH_EMAILS_TEMPLATES + '/create',
  SEARCH_EMAILS_TEMPLATES_EDIT: ROUTE.SEARCH_EMAILS_TEMPLATES + '/:id(\\d+)',
  SEARCH_SUBSCRIPTION_PROFILE:
    '/recruiter/:page(subscription-searches)/:id(\\d+)',
  SEARCH_SUBSCRIPTION_EDIT:
    '/recruiter/:page(subscription-searches)/:id(\\d+)/:action(edit)',
  SEARCH_VIEW_APPLICANTS:
    '/recruiter/:type(process|project)/:id(\\d+)/applicants',

  SEARCH_PROJECT_PROFILE: ROUTE.SEARCH_PROJECT_MANAGE + '/:id(\\d+)',
  SEARCH_PROJECT_MANAGE: ROUTE.SEARCH_PROJECT_MANAGE + '/:closed(closed)',
  SEARCH_PROJECT_ACTIONS: [
    '/recruiter/:page(project)/:action(create)',
    '/recruiter/:page(project)/:id(\\d+)/:action(edit)',
  ],

  SEARCH_JOB_PROFILE: ROUTE.SEARCH_PROCESS_MANAGE + '/:id(\\d+)',
  SEARCH_PROCESS_MANAGE: ROUTE.SEARCH_PROCESS_MANAGE + '/:closed(closed)',
  SEARCH_PROCESS_ACTIONS: [
    '/recruiter/:page(process)/:action(create)',
    '/recruiter/:page(process)/:id(\\d+)/:action(edit)',
  ],
  SEARCH_PROCESS_SETUP_EMAIL:
    '/recruiter/:type(process|project)/:id(\\d+)/email-setup',

  SEARCH_SHORTLIST_SHARE: ROUTE.SEARCH_SHORTLIST + '/:tab(shared)',

  CANDIDATE_PROFILE: '/candidate/:id(\\d+)',
  CANDIDATE_PROFILE_EDITOR: '/candidate/edit-profile/:id(\\d+)',

  PROCESS_PUBLIC: '/:type(process|project)/:id',
  STUDENT: '/student/:page(school|signup|questions|interests|success|create-profile|complete)',
  STUDENT_HELLO: '/student/:page(hello)/:school',
};

export default ROUTE;
